import { Injectable } from '@angular/core';
import { RankData } from '../store-item';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class RankingService {

  private itemsUrl = 'assets/store.json';  // URL to web api
  private hotItemsUrl = 'assets/hotstore.json';  // URL to web api

  constructor(
    private http: HttpClient) { }
    
  getRanking(server: string): Observable<RankData> {
    // return this.http.get<StoreData[]>("https://localhost/raid/store.php?AccountName=" + this.getParameterByName("username"))
    // return this.http.get<RankData>(this.itemsUrl)
    return this.http.get<RankData>("https://wyd.raidhut.com.br/raid/rankings.php?server=" + server + "&username=" + this.getParameterByName("username"))
    .pipe(
    );
  }

  private getParameterByName(name: any):string {
    let url = window.location.href;
    name = name.replace(/[[]]/g, "\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace("/+/g", " "));
  }
}
